import { useClassName } from './useClassName';
import { styleRule } from './styleRule';
import { LooseProps, splitProps } from './props';

export function Checkbox(props: LooseProps) {
  const {
    sx,
    className,
    checked,
    disabled,
    onChange,
    tabIndex,
    disableRipple: _disableRipple,
    ...rest
  } = props;
  const { system, dom } = splitProps(rest);
  const {
    className: resolvedClass,
    css,
    styleId,
  } = useClassName([{ width: '18px', height: '18px', ...system }, sx], undefined, className);
  return (
    <>
      {styleRule(styleId, css)}
      <input
        {...dom}
        type="checkbox"
        className={resolvedClass}
        checked={Boolean(checked)}
        disabled={disabled}
        tabIndex={tabIndex}
        onChange={onChange || (() => undefined)}
      />
    </>
  );
}
